import Vue from "vue";
import { DiscountData} from "@/types";
import {MutationTree} from "vuex";
import { DiscountState } from "@/types/store/adminzone";

export const mutations: MutationTree<DiscountState> = {
  SET_DISCOUNTS: (state, payload: Array<DiscountData>): Array<DiscountData> => Vue.set(state, "discounts", payload),
  SET_DISCOUNTS_TOTAL_COUNT: (state, payload: number): number => Vue.set(state, 'discountsTotalCount', payload)
}
